import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styles from "./homeArticles.module.css";
import useTranslation from 'next-translate/useTranslation';
import { getArticles } from "../../../api/requests";

var Articles = function Articles() {
  var _useState = useState(''),
      articles = _useState[0],
      setArticles = _useState[1]; // console.log("props: ",props);


  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  useEffect(function () {
    getArticles().then(function (res) {
      setArticles(res.data);
    })["catch"](function (err) {
      console.log('articles err', err);
    });
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(styles.wrapper),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      style: {
        direction: isRTL ? 'rtl' : 'ltr'
      },
      children: [/*#__PURE__*/_jsx("a", {
        target: "_blank",
        href: "https://wowmagazine.ir",
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.title,
          style: {
            display: isRTL ? 'flex' : ''
          },
          children: [/*#__PURE__*/_jsx("h2", {
            className: styles.articlesTitle,
            style: {
              cursor: 'pointer'
            },
            children: t('home:woWMagazine')
          }), /*#__PURE__*/_jsx("h2", {
            className: styles.articleTitle,
            style: {
              cursor: 'pointer'
            },
            children: t('home:woWMagazine')
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "".concat(styles.articles, " row"),
        children: articles && articles.map(function (item, i) {
          var _item$guid, _item$uagb_featured_i, _item$uagb_featured_i2, _item$title;

          return /*#__PURE__*/_jsx("div", {
            className: "".concat(styles.article, " col-12 col-sm-6 col-lg-3"),
            children: /*#__PURE__*/_jsx("a", {
              target: "_blank",
              href: item === null || item === void 0 ? void 0 : (_item$guid = item.guid) === null || _item$guid === void 0 ? void 0 : _item$guid.rendered,
              children: /*#__PURE__*/_jsxs("div", {
                className: styles.shadow,
                children: [/*#__PURE__*/_jsx("img", {
                  src: item === null || item === void 0 ? void 0 : (_item$uagb_featured_i = item.uagb_featured_image_src) === null || _item$uagb_featured_i === void 0 ? void 0 : (_item$uagb_featured_i2 = _item$uagb_featured_i.medium) === null || _item$uagb_featured_i2 === void 0 ? void 0 : _item$uagb_featured_i2[0],
                  alt: ""
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.headerWrapper,
                  children: /*#__PURE__*/_jsx("p", {
                    className: isRTL ? styles.articleHeaderFa : styles.articleHeaderEng,
                    children: item === null || item === void 0 ? void 0 : (_item$title = item.title) === null || _item$title === void 0 ? void 0 : _item$title.rendered
                  })
                })]
              })
            })
          }, i);
        })
      }), /*#__PURE__*/_jsxs("a", {
        href: "https://wowmagazine.ir",
        target: "_blank",
        className: "".concat(styles.more, " ").concat(isRTL ? styles.moreFa : styles.moreEn),
        children: [t('home:more'), " ", /*#__PURE__*/_jsx("div", {
          children: "..."
        })]
      })]
    })
  });
};

export default Articles;